import { render, staticRenderFns } from "./AddLifestyleProgramCategoryDialog.vue?vue&type=template&id=28b237ce"
import script from "./AddLifestyleProgramCategoryDialog.ts?vue&type=script&lang=js&external"
export * from "./AddLifestyleProgramCategoryDialog.ts?vue&type=script&lang=js&external"
import style0 from "./AddLifestyleProgramCategoryDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports